import Dropdown from 'mcs-toolkit/components/Dropdown';
import React from 'react';
import { DropdownProps } from 'semantic-ui-react';

import { BasicField } from './_BasicField';

type Props = DropdownProps & {
    label?: string;
    name?: string;
    options?: any;
    onChange?: (...args: any[]) => any;
    disabled?: boolean;
    hidden?: boolean;
    fluid?: boolean;
    multiple?: boolean;
    selection?: boolean;
    dataTest?: string;
};

export const FieldMultipleSelect = ({
    label,
    name,
    options,
    onChange,
    disabled,
    hidden,
    fluid = true,
    multiple = true,
    selection = true,
    dataTest = 'multiple-select',
    ...otherSelectProps
}: Props) => (
    // @ts-ignore
    <BasicField
        data-test={dataTest}
        {...{
            ...otherSelectProps,
            label,
            name,
            options,
            onChange,
            control: Dropdown,
            hidden,
            disabled,
            fluid,
            multiple,
            selection,
        }}
    />
);
